var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex min-vh-100 flex-column justify-content-between",attrs:{"id":"app"}},[_c('Header'),_c('section',{class:{'app-user': _vm.app === 'user'},attrs:{"id":"content"}},[_c('router-view')],1),_c(_vm.footer,{tag:"Component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }